import { Avatar, Form } from 'antd';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import ExperiencieIcfesList from '../../../pages/ExperiencieIcfes/List';

import { CustomButton } from '../../../components';
import { Card, Typography, Radio, Space, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { AppstoreOutlined, PlusOutlined } from '@ant-design/icons';
const { Title, Paragraph } = Typography;

const NaturalPersonICFESFormExperienceSection = ({
  readOnly = false,
  personID,
  divRef,
  loading,
}) => {
  return (
    <Card
      size={'small'}
      bordered={false}
      title={
        <Title level={3}>
          <Avatar
            size={32}
            icon={<AppstoreOutlined />}
            style={{ backgroundColor: '#20b2aa', color: 'white' }}
            shape="square"
          />{' '}
          Experiencia ICFES
        </Title>
      }
    >
      <div ref={divRef}>
        <Form.Item
          label="¿Ha tenido algún tipo de contratación con el ICFES?"
          name="experiencia_icfes"
        >
          <Radio.Group disabled={readOnly}>
            <Radio value={true}>Si</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Space direction={'vertical'}>
          {!readOnly && (
            <CustomButton loading={loading} htmlType="submit" text="Guardar" />
          )}
        </Space>
        <Form.Item noStyle dependencies={['experiencia_icfes']}>
          {({ getFieldValue }) =>
            getFieldValue('experiencia_icfes') ? (
              <Row gutter={12}>
                <Col span={24}>
                  {readOnly ? (
                    <Paragraph style={{ marginTop: 10 }}>
                      A continuación, se lista su experiencia
                    </Paragraph>
                  ) : (
                    <>
                      <Paragraph style={{ marginTop: 10 }}>
                        A continuación, agregue su experiencia
                      </Paragraph>
                      <CustomButton
                        type={'default'}
                        className={'ant-btn-info'}
                        htmlType="button"
                        text={
                          <Link
                            to={`${INTERNAL_LINKS.EXPERIENCIE_ICFES}/${personID}`}
                          >
                            <PlusOutlined /> Agregar experiencia ICFES
                          </Link>
                        }
                      />
                    </>
                  )}
                  <ExperiencieIcfesList
                    idTercero={personID}
                    readOnly={readOnly}
                  />
                </Col>
              </Row>
            ) : null
          }
        </Form.Item>
      </div>
    </Card>
  );
};

export default NaturalPersonICFESFormExperienceSection;
